import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {MessageService} from 'primeng/api';
import {AuthService} from '../../service/auth.service';
import {CommonModule} from '@angular/common';
import {ButtonModule} from 'primeng/button';
import {CheckboxModule} from 'primeng/checkbox';
import {FormsModule} from '@angular/forms';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {PasswordModule} from 'primeng/password';
import {InputTextModule} from 'primeng/inputtext';
import {ToastModule} from 'primeng/toast';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {ThemeService} from "../../service/theme.service";
import {ForgotPasswordComponent} from "../forgot-password/forgot-password.component";
import {DialogService} from "primeng/dynamicdialog";
import {LoaderService} from "../../service/loader.service";
import {finalize} from "rxjs";
import {RoleEnum} from "../../core/guards/RoleEnum.enum";
import { User } from '../../models/user.model';
import {GA4Service} from "../../service/ga4.service";

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    CheckboxModule,
    InputTextModule,
    FormsModule,
    PasswordModule,
    MessagesModule,
    TranslateModule,
    MessageModule,
    ButtonModule,
    ToastModule,
  ],
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [MessageService, DialogService],
})
export class LoginComponent implements OnInit, OnDestroy {

  isLoading = false;

  password!: string;

  model: any = {};

  constructor(
    public authService: AuthService,
    private readonly router: Router,
    public service: MessageService,
    public themeService: ThemeService,
    public dialogService: DialogService,
    public loader: LoaderService,
    private readonly translateService: TranslateService,
    private ga4Service: GA4Service) {
  }

  ngOnDestroy() {
    this.themeService.disableMsgSessaoExpirada();
    this.authService.disableChangePassSuccess();
    window.removeEventListener('message', this.handlePostMessage);
  }

  ngOnInit() {
    window.addEventListener('message', this.handlePostMessage);
  }
  private handlePostMessage = (event: MessageEvent) => {
    if (event.data?.type === 'init') {
      const token = event.data.token;
      const page = event.data.page;
      localStorage.setItem('user', JSON.stringify(this.authService.decrypt(decodeURIComponent(token),true)));
      this.authService.setUserFromToken(decodeURIComponent(token));
      this.themeService.disableHeader();
      this.hadleLoginSuccess();
    }
  }

  login() {
    if (this.isLoading)
      return;

    this.loader.putMsgLoader('Realizando login...');
    this.isLoading = true;
    this.authService.login(this.model)
      .pipe(finalize(() => {
        this.loader.hideLoader();
        this.isLoading = false;
      }))
      .subscribe({
        next: (v: any) => {
          this.hadleLoginSuccess();
        },
        error: err => {
          console.error(err)
          const detail = err?.toString()?.includes('grupo')
            ? err : this.translateService.instant('login.loginError');
          this.service.add({
            key: 'tst_login',
            severity: 'error',
            summary: this.translateService.instant('alert.toast.errorTitle'),
            detail: detail
          });
          this.isLoading = false;
        }
      })
  }

  private hadleLoginSuccess() {
    // Registra o acesso do usuário no GA4 após login bem sucedido
    this.ga4Service.trackUserAccess();
    
    if (this.authService.getCurrentUser().forceChangePassword) {
      this.router.navigate(['change-password']);
    } else {
      if (this.authService.hasRoles([RoleEnum.MAPA]))
        this.router.navigateByUrl('pages/map');
      else
        this.router.navigateByUrl('pages');
    }
  }

  logout() {
    this.authService.logout();
    this.router.navigateByUrl('/');
  }

  show() {
    if (this.isLoading)
      return;

    this.dialogService.open(ForgotPasswordComponent, {
      header: 'Esqueci a senha',
      height: '40%',
      width: '30%',
      styleClass: 'dialog-forgot'
    });
  }
}
